import React, { useState, useEffect } from "react";
import MorningBriefingDateDetailModal from "./MorningBriefingDateDetailModal";
import { commonService } from "../../../utils/commonService";
import { Table, Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import moment from "moment";
import Loader from "../../Loader/Loader";

const PickupAndPace = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty?.propertyDetail,
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty?.defaultAsOfDate,
    );
    const [tblids, settblids] = useState({
        PickupAndPaceTable: commonService.GenerateGUID(),
    });
    const widgetDetailRef = React.useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [modalData, setModalData] = useState([]);
    const [data, setData] = useState([]);
    const [showDetail, setShowDetail] = useState(false);
    const [selectedDateData, setSelectedDateData] = useState(null);
    const [rateShopData, setRateShopData] = useState(null);
    const [bookingPaceData, setBookingPaceData] = useState(null);
    const [marketSegmentMixData, setMarketSegmentMixData] = useState([]);
    const [isLoadingRateShop, setIsLoadingRateShop] = useState(false);
    const [isLoadingBookingPace, setIsLoadingBookingPace] = useState(false);
    const [loadingOccData, setLoadingOccData] = useState(false);
    const [isLoadingMarketSegmentMix, setIsLoadingMarketSegmentMix] =
        useState(false);

    const fetchData = async () => {
        // setLoading(true);
        try {
            const startDate = moment(para?.asOfDate || new Date());

            const standardPayload = {
                AsOfDate: para?.asOfDate,
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: moment(startDate).add(30, "days").format("YYYY-MM-DD"),
                propertyCode: para?.propertyCode,
            };

            const flagMechanismPayload = {
                asofdate: para?.asOfDate,
                startdate: startDate.format("YYYY-MM-DD"),
                enddate: moment(startDate).add(30, "days").format("YYYY-MM-DD"),
                propertyCode: para?.propertyCode,
            };

            const displacementPayload = {
                asofdate: para?.asOfDate,
                startdate: startDate.format("YYYY-MM-DD"),
                enddate: moment(startDate).add(30, "days").format("YYYY-MM-DD"),
                propertycode: para?.propertyCode,
            };

            const pricingforecastPayload = {
                AsOfDate: commonService.getDateForNode(para?.asOfDate),
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: moment(startDate).add(30, "days").format("YYYY-MM-DD"),
                propertyCode: para?.propertyCode,
                propertyid: para?.propertyDetail?.propertyid,
                ForcastType: "ema",
            };

            const eventPayload = {
                pageNum: 1,
                pageSize: 100,
                sortColumn: "",
                sortDirection: "asc",
                searchValue: "",
                propertyid: parseInt(para?.propertyDetail?.propertyid || 0),
                startdate: null,
                enddate: null,
                eventname: "",
                eventtypeterm: "",
                yearterm: "",
            };

            // Fetch OTB
            const otbPromise = apiCall({
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
                body: standardPayload,
            });

            // Fetch Forecast
            const forecastPromise = apiCall({
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                body: pricingforecastPayload,
            });

            // Fetch STLY Pace
            const stlyPromise = apiCall({
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
                body: standardPayload,
            });

            // Fetch Events
            const eventsPromise = apiCall({
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: eventPayload,
            });

            // Fetch BAR
            const barPromise = apiCall({
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
                body: standardPayload,
            });

            // Fetch Comp Set
            const compSetPromise = apiCall({
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DISPLACEMENT.DISPLACEMENT_TRANSIENT_OTB_FORECAST,
                body: displacementPayload,
            });

            // Fetch Flag Mechanism
            const flagPromise = apiCall({
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
                body: flagMechanismPayload,
            });

            const [
                otbRes,
                forecastRes,
                stlyRes,
                eventsRes,
                barRes,
                compSetRes,
                flagRes,
            ] = await Promise.all([
                otbPromise,
                forecastPromise,
                stlyPromise,
                eventsPromise,
                barPromise,
                compSetPromise,
                flagPromise,
            ]);
            // Process live responses
            const extractData = (res) =>
                apiResponse(false, res)?.data?.data ||
                apiResponse(false, res)?.data ||
                [];

            const otbData = extractData(otbRes);
            const forecastData = extractData(forecastRes);
            const stlyData = extractData(stlyRes);
            const eventsData = extractData(eventsRes);
            const barData = extractData(barRes);
            const compSetData = extractData(compSetRes);
            const flagData = extractData(flagRes);

            const getArrData = (dataArray) =>
                Array.isArray(dataArray) ? dataArray : [];
            let days = [];
            for (let i = 0; i < 30; i++) {
                let current = moment(startDate).add(i, "days");
                let currentStr = current.format("YYYY-MM-DD");

                let otbMatch = getArrData(otbData).find(
                    (x) =>
                        (x.Date && x.Date.startsWith(currentStr)) ||
                        (x.Dates && x.Dates.startsWith(currentStr)),
                );
                let forecastMatch = getArrData(forecastData).find(
                    (x) =>
                        (x.Dates && x.Dates.startsWith(currentStr)) ||
                        (x.Date && x.Date.startsWith(currentStr)),
                );
                let stlyMatch = getArrData(stlyData).find(
                    (x) =>
                        (x.dates && x.dates.startsWith(currentStr)) ||
                        (x.Date && x.Date.startsWith(currentStr)),
                );
                let eventsMatch = getArrData(eventsData).find(
                    (x) =>
                        (x.startdate &&
                            moment(x.startdate).format("YYYY-MM-DD") === currentStr) ||
                        (x.event_start_date &&
                            moment(x.event_start_date).format("YYYY-MM-DD") === currentStr),
                );
                let abc = getArrData(barData).filter((x) => x.IsSelf === true);
                let currentDateBarData = getArrData(barData).filter(
                    (x) =>
                        (x.CheckInDate && x.CheckInDate.startsWith(currentStr)) ||
                        (x.Date && x.Date.startsWith(currentStr)),
                );

                let myBarMatch = currentDateBarData.find((x) => x.IsSelf === true);
                let myBarRate = myBarMatch
                    ? parseFloat(myBarMatch.Rate || myBarMatch.rate || 0)
                    : 0;

                let compRates = currentDateBarData
                    .filter((x) => x.IsSelf === false)
                    .map((x) => parseFloat(x.Rate || x.rate || 0))
                    .filter((rate) => rate > 0);

                let compSetAvgValue =
                    compRates.length > 0
                        ? compRates.reduce((a, b) => a + b, 0) / compRates.length
                        : 0;

                compSetAvgValue = Math.round(compSetAvgValue * 100) / 100;

                let rateIqValue = "";
                if (myBarRate < compSetAvgValue) {
                    rateIqValue = "underpriced";
                } else if (myBarRate > compSetAvgValue) {
                    rateIqValue = "overprised";
                } else {
                    rateIqValue = "same";
                }

                let compSetMatch = getArrData(compSetData).find(
                    (x) =>
                        (x.Dates && x.Dates.startsWith(currentStr)) ||
                        (x.Date && x.Date.startsWith(currentStr)),
                );
                let flagMatch = getArrData(flagData).find(
                    (x) =>
                        (x.dates && x.dates.startsWith(currentStr)) ||
                        (x.Date && x.Date.startsWith(currentStr)),
                );

                const colorMap = {
                    RED: "#da3633",
                    GREEN: "#238636",
                    YELLOW: "#d29922",
                    ORANGE: "#d29922",
                };
                const rawFlagColor = flagMatch
                    ? flagMatch.flag_color || flagMatch.color
                    : null;
                const resolvedColor =
                    rawFlagColor && colorMap[rawFlagColor.toUpperCase()]
                        ? colorMap[rawFlagColor.toUpperCase()]
                        : "#d0d7de";

                days.push({
                    date: currentStr,
                    displayDate: current.format("M/D"),
                    otbOcc: otbMatch ? (otbMatch.OnTheBook ?? 0) : 0,
                    // novaForecast:
                    //   forecastMatch && forecastMatch.RMS != null ? forecastMatch.RMS : 0,
                    novaForecast: forecastMatch?.RMS != null ? forecastMatch.RMS : 0,
                    stlyPace: stlyMatch ? (stlyMatch.stlyotb ?? 0) : 0,

                    hasEvent: !!eventsMatch,
                    demandScoreColor: resolvedColor,
                    demandScore: compSetMatch ? (compSetMatch.TotalDemandScore ?? 0) : 0,
                    myBar: myBarRate,

                    compSetAvg: compSetAvgValue,
                    flagColor: resolvedColor,
                    eventName: eventsMatch
                        ? eventsMatch.eventname ||
                        eventsMatch.event_name ||
                        eventsMatch.title ||
                        ""
                        : "",
                    flagText: flagMatch
                        ? flagMatch.message ||
                        flagMatch.flag_text ||
                        flagMatch.description ||
                        ""
                        : "",
                    rateIq: rateIqValue,
                });
            }

            setModalData(days);
        } catch (e) {
        } finally {
            // setLoading(false);
        }
    };

    const getOccData = async () => {
        setLoadingOccData(true);
        const startDate = moment(para?.asOfDate || new Date());
        const endDate = moment(startDate).add(13, "days");
        let pickupDate1 = moment(para?.asOfDate || new Date()).subtract(1, "days");
        let pickupDate3 = moment(para?.asOfDate || new Date()).subtract(3, "days");
        let pickupDate7 = moment(para?.asOfDate || new Date()).subtract(7, "days");

        let occDataPromise = apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.RATEIQ_YIELD.GET_OCCUPANCY_BY_DATES,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: startDate.format("YYYY-MM-DD"),
                    endDate: endDate.format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                },
            },
            false,
        );

        let pickup1DPromise = apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.STRATEGY_BY_RESERVATION_PICKUP,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: startDate.format("YYYY-MM-DD"),
                    endDate: endDate.format("YYYY-MM-DD"),
                    PickUpDate: pickupDate1.format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    pickupType: "oneDay",
                },
            },
            false,
        );

        let pickup3DPromise = apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.STRATEGY_BY_RESERVATION_PICKUP,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: startDate.format("YYYY-MM-DD"),
                    endDate: endDate.format("YYYY-MM-DD"),
                    PickUpDate: pickupDate3.format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    pickupType: "threeDay",
                },
            },
            false,
        );

        let pickup7DPromise = apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.STRATEGY_BY_RESERVATION_PICKUP,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: startDate.format("YYYY-MM-DD"),
                    endDate: endDate.format("YYYY-MM-DD"),
                    PickUpDate: pickupDate7.format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    pickupType: "sevenDay",
                },
            },
            false,
        );

        let forecastPromise = apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                body: {
                    AsOfDate: commonService.getDateForNode(para?.asOfDate),
                    startDate: startDate.format("YYYY-MM-DD"),
                    endDate: endDate.format("YYYY-MM-DD"),
                    propertyCode:
                        para?.propertyDetail?.propertycode || para?.propertyCode,
                    propertyid: para?.propertyDetail?.propertyid,
                    ForcastType: (para?.propertyDetail?.revenuconfig?.[0]
                        ?.forcasttype_term
                        ? para?.propertyDetail?.revenuconfig[0]?.forcasttype_term
                        : "ema"
                    ).toLowerCase(),
                },
            },
            false,
        );

        let [
            occDataResponse,
            pickup1DResponse,
            pickup3DResponse,
            pickup7DResponse,
            forecastResponse,
        ] = await Promise.all([
            occDataPromise,
            pickup1DPromise,
            pickup3DPromise,
            pickup7DPromise,
            forecastPromise,
        ]);

        let resOcc = apiResponse(false, occDataResponse);
        let resPickup1D = apiResponse(false, pickup1DResponse);
        let resPickup3D = apiResponse(false, pickup3DResponse);
        let resPickup7D = apiResponse(false, pickup7DResponse);
        let resForecast = apiResponse(false, forecastResponse);

        let apiDataOcc = resOcc?.isValidate ? resOcc?.data?.data || [] : [];
        let apiDataPickup1D = resPickup1D?.isValidate
            ? resPickup1D?.data?.data || []
            : [];
        let apiDataPickup3D = resPickup3D?.isValidate
            ? resPickup3D?.data?.data || []
            : [];
        let apiDataPickup7D = resPickup7D?.isValidate
            ? resPickup7D?.data?.data || []
            : [];
        let apiDataForecast = resForecast?.isValidate
            ? resForecast?.data?.data || []
            : [];

        let pickup1DByDate = {};
        apiDataPickup1D.forEach((item, index) => {
            let dateForTd = moment(startDate).add(index, "days").format("YYYY-MM-DD");
            pickup1DByDate[dateForTd] = item;
        });

        let pickup3DByDate = {};
        apiDataPickup3D.forEach((item, index) => {
            let dateForTd = moment(startDate).add(index, "days").format("YYYY-MM-DD");
            pickup3DByDate[dateForTd] = item;
        });

        let pickup7DByDate = {};
        apiDataPickup7D.forEach((item, index) => {
            let dateForTd = moment(startDate).add(index, "days").format("YYYY-MM-DD");
            pickup7DByDate[dateForTd] = item;
        });

        let forecastByDate = {};
        apiDataForecast.forEach((item) => {
            let d =
                item.StayDate ||
                item.Date ||
                item.CheckInDate ||
                item.date ||
                item.Dates;
            if (d) {
                forecastByDate[moment(d).format("YYYY-MM-DD")] = item;
            }
        });

        if (
            resOcc?.isValidate ||
            resPickup1D?.isValidate ||
            resPickup3D?.isValidate ||
            resPickup7D?.isValidate ||
            resForecast?.isValidate
        ) {
            let datesArr = [];
            for (let i = 0; i < 14; i++) {
                datesArr.push(moment(startDate).add(i, "days").format("YYYY-MM-DD"));
            }

            let formattedData = datesArr.map((dateStr) => {
                let occItem =
                    apiDataOcc.find((item) => {
                        let d =
                            item.StayDate ||
                            item.Date ||
                            item.CheckInDate ||
                            item.date ||
                            item.Dates;
                        return d && moment(d).format("YYYY-MM-DD") === dateStr;
                    }) || {};

                let pu1Item = pickup1DByDate[dateStr] || {};
                let pu3Item = pickup3DByDate[dateStr] || {};
                let pu7Item = pickup7DByDate[dateStr] || {};
                let fcItem = forecastByDate[dateStr] || {};

                let otbVal = occItem ? (occItem?.RMS ? occItem?.RMS : 0) : 0;
                let sysfcVal = fcItem ? (fcItem.RMS ? fcItem.RMS : 0) : 0;

                let pu1dVal = pu1Item ? (pu1Item.RMS ? pu1Item.RMS : 0) : 0;
                let pu3dVal = pu3Item ? (pu3Item.RMS ? pu3Item.RMS : 0) : 0;
                let pu7dVal = pu7Item ? (pu7Item.RMS ? pu7Item.RMS : 0) : 0;
                const vsSTLYVal = occItem
                    ? (occItem.RMS ?? 0) - (occItem.STLY_RMS ?? 0)
                    : 0;

                return {
                    date: moment(dateStr).format("ddd M/D"),
                    otb: `${otbVal}`,
                    novaFc: sysfcVal !== undefined ? `${sysfcVal}` : "0",
                    pu1d: pu1dVal ? pu1dVal : 0,
                    pu3d: pu3dVal ? pu3dVal : 0,
                    pu7d: pu7dVal ? pu7dVal : 0,
                    vsStly: vsSTLYVal !== undefined ? vsSTLYVal : 0,
                    bar: occItem.BAR !== undefined ? occItem.BAR : 0,
                    signal: occItem.Signal || "",
                    ...occItem,
                    ...fcItem,
                };
            });
            setData(formattedData);
        } else {
            setData([]);
        }
        setLoadingOccData(false);
    };

    useEffect(() => {
        if (api === 0) {
            const startDate = moment(para?.asOfDate || new Date());

            // Build 14-day static data for the table
            const staticTableData = [];
            const signals = ["AHEAD", "BEHIND", "RATE FLAT", "AHEAD"];
            for (let i = 0; i < 14; i++) {
                const current = moment(startDate).add(i, "days");
                const currentStr = current.format("YYYY-MM-DD");
                const otbVal = Math.min(
                    100,
                    Math.floor(45 + Math.sin(i * 0.5) * 20 + (i % 4) * 5)
                );
                const sysfcVal = Math.min(
                    100,
                    Math.floor(65 + Math.cos(i * 0.4) * 15 + (i % 3) * 6)
                );
                const pu1dVal = Math.floor(2 + (i % 4));
                const pu3dVal = Math.floor(5 + (i % 5) * 2);
                const pu7dVal = Math.floor(12 + (i % 6) * 3);
                const vsSTLYVal = Math.floor(-5 + Math.sin(i) * 15);
                const barVal = 150 + (i % 7) * 12;
                const signalVal = signals[i % signals.length];

                staticTableData.push({
                    date: current.format("ddd M/D"),
                    Dates: currentStr,
                    otb: `${otbVal}`,
                    novaFc: `${sysfcVal}`,
                    pu1d: pu1dVal,
                    pu3d: pu3dVal,
                    pu7d: pu7dVal,
                    vsStly: vsSTLYVal,
                    bar: barVal,
                    signal: signalVal,
                });
            }
            setData(staticTableData);

            // Build 30-day static data for modal details
            const staticModalDays = [];
            const dummyEvents = {
                5: "Tech Conference",
                12: "City Concert",
                20: "Marathon",
            };
            const colors = ["#238636", "#d29922", "#da3633", "#238636"];

            for (let i = 0; i < 30; i++) {
                const current = moment(startDate).add(i, "days");
                const currentStr = current.format("YYYY-MM-DD");
                const hasEvent = !!dummyEvents[i];
                const otbOcc = Math.min(
                    100,
                    Math.floor(45 + Math.sin(i * 0.5) * 20 + (i % 4) * 5)
                );
                const novaForecast = Math.min(
                    100,
                    Math.floor(65 + Math.cos(i * 0.4) * 15 + (i % 3) * 6)
                );
                const stlyPace = Math.min(
                    100,
                    Math.floor(55 + Math.sin(i * 0.3) * 15)
                );
                const myBar = 150 + (i % 7) * 12 + Math.floor(Math.sin(i) * 25);
                const compSetAvg = 160 + (i % 5) * 10 + Math.floor(Math.cos(i) * 20);
                const demandScore = Math.floor(60 + Math.sin(i * 0.6) * 30);
                const resolvedColor = colors[i % colors.length];

                let rateIqValue = "same";
                if (myBar < compSetAvg) {
                    rateIqValue = "underpriced";
                } else if (myBar > compSetAvg) {
                    rateIqValue = "overprised";
                }

                staticModalDays.push({
                    date: currentStr,
                    displayDate: current.format("M/D"),
                    otbOcc,
                    novaForecast,
                    stlyPace,
                    hasEvent,
                    demandScoreColor: resolvedColor,
                    demandScore,
                    myBar,
                    compSetAvg,
                    flagColor: resolvedColor,
                    eventName: hasEvent ? dummyEvents[i] : "",
                    flagText: hasEvent ? "High Demand Event" : "",
                    rateIq: rateIqValue,
                });
            }
            setModalData(staticModalDays);
            setLoadingOccData(false);
        } else {
            if (para?.asOfDate && para?.propertyCode) {
                fetchData(); // For Modal data
                getOccData();
            }
        }
    }, [para?.asOfDate, para?.propertyCode, api]);

    useEffect(() => {
        if (selectedDateData) {
            getRateShopData();
            getBookingPaceDetail();
            getMarketSegmentMixDetails();
        }
    }, [selectedDateData, para?.asOfDate, para?.propertyDetail]);

    const getBookingPaceDetail = async () => {
        let selectedDate = selectedDateData?.date || selectedDateData?.dates;
        if (para?.asOfDate && selectedDate) {
            setIsLoadingBookingPace(true);
            try {
                let bookingPaceResponse = await apiCall(
                    {
                        method: "POST",
                        url:
                            API_URL.BASE_API_URL.SnapShot +
                            API_URL.BOOKING_PACE.NEW_BOOKING_PACE,
                        body: {
                            asofdate: para?.asOfDate,
                            propertycode: para?.propertyCode,
                            startdate: commonService.getDateInDBFormat(selectedDate),
                            enddate: commonService.getDateInDBFormat(selectedDate),
                        },
                    },
                    false,
                );

                let response = apiResponse(false, bookingPaceResponse);

                if (response?.isValidate) {
                    let dataFromApi = response?.data?.data;
                    if (dataFromApi && dataFromApi.length > 0) {
                        let labels = [];
                        let RMS = [];
                        let STLYRMS = [];

                        // The mock chart goes from largest lead time (left) to smallest (right).
                        // Sorting descending just in case.
                        let sortedData = [...dataFromApi].sort(
                            (a, b) => b.leadtime - a.leadtime,
                        );

                        sortedData.forEach((item) => {
                            labels.push(item.leadtime + "d");
                            RMS.push(item.currentyearper);
                            STLYRMS.push(item.STLYper);
                        });

                        setBookingPaceData({
                            labels,
                            RMS,
                            STLYRMS,
                        });
                    } else {
                        setBookingPaceData(null);
                    }
                }

                if (!response?.isValidate) {
                    setBookingPaceData(null);
                }
            } catch (error) {
                setBookingPaceData(null);
            } finally {
                setIsLoadingBookingPace(false);
            }
        }
    };

    const getRateShopData = async () => {
        let propertyDetailFromRTK = para?.propertyDetail;
        let asOfDate = para?.asOfDate;
        let selectedDate = selectedDateData?.date || selectedDateData?.dates;

        setIsLoadingRateShop(true);
        try {
            let byPropertyIdResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                    body: {
                        id: propertyDetailFromRTK?.propertyid,
                    },
                },
                false,
            );

            let propertyResponse = apiResponse(false, byPropertyIdResponse);

            let CompareDate = new Date(asOfDate);
            CompareDate = new Date(CompareDate.setDate(CompareDate.getDate() - 1));

            let rateShopDataResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
                    body: {
                        AsOfDate: asOfDate,
                        propertyCode: propertyDetailFromRTK?.propertycode,
                        Channel: propertyResponse?.data?.data?.channel_term
                            ? propertyResponse?.data?.data?.channel_term
                            : "",
                        startDate: selectedDate
                            ? commonService.getDateForNode(selectedDate)
                            : "",
                        endDate: selectedDate
                            ? commonService.getDateForNode(selectedDate)
                            : "",
                        propertyid: propertyDetailFromRTK?.propertyid,
                        CompareDate: CompareDate
                            ? commonService.getDateInDBFormat(CompareDate)
                            : "",
                    },
                },
                false,
            );

            let response = apiResponse(false, rateShopDataResponse);

            if (response?.isValidate) {
                setRateShopData(response?.data?.data);
            }

            if (!response?.isValidate) {
                setRateShopData(null);
            }
        } catch (error) {
            setRateShopData(null);
        } finally {
            setIsLoadingRateShop(false);
        }
    };

    const getMarketSegmentMixDetails = async () => {
        let selectedDate = selectedDateData?.date || selectedDateData?.dates;
        if (para?.asOfDate && selectedDate) {
            setIsLoadingMarketSegmentMix(true);
            let customday = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.MONEY_CONTROL.MARKETSEGMENT_MIX_CHART,
                    body: {
                        propertyCode: para?.propertyCode,
                        AsOfDate: para?.asOfDate,
                        startDate: commonService.getDateForNode(selectedDate),
                        endDate: commonService.getDateForNode(selectedDate),
                    },
                },
                false,
            );

            let customdayresponse = apiResponse(false, customday);

            if (customdayresponse?.isValidate) {
                setMarketSegmentMixData(customdayresponse?.data?.data);
            } else {
                setMarketSegmentMixData([]);
            }
            setIsLoadingMarketSegmentMix(false);
        }
    };

    const renderColorText = (text) => {
        if (text > 0) {
            return <span style={{ color: "#16a34a" }}>{text}</span>;
        }
        if (text < 0) {
            return <span style={{ color: "#dc2626" }}>{text}</span>;
        }
        return <span style={{ color: "#16a34a" }}>{text}</span>;
    };

    const getBadgeStyle = (signal) => {
        switch (signal) {
            case "EVENT":
                return {
                    // backgroundColor: "rgba(59, 130, 246, 0.15)",
                    color: "#1d4ed8",
                    // border: "1px solid rgba(59, 130, 246, 0.4)",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                };
            case "ON PACE":
                return {
                    // backgroundColor: "rgba(34, 197, 94, 0.15)",
                    color: "#15803d",
                    // border: "1px solid rgba(34, 197, 94, 0.4)",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                };
            case "BEHIND":
                return {
                    // backgroundColor: "rgba(234, 179, 8, 0.15)",
                    color: "#b45309",
                    // border: "1px solid rgba(234, 179, 8, 0.4)",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                };
            case "RATE FLAT":
                return {
                    // backgroundColor: "rgba(239, 68, 68, 0.15)",
                    color: "#b91c1c",
                    // border: "1px solid rgba(239, 68, 68, 0.4)",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                };
            default:
                return {
                    // backgroundColor: "rgba(239, 68, 68, 0.15)",
                    // color: "#b91c1c",
                    // border: "1px solid rgba(239, 68, 68, 0.4)",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                };
        }
    };

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img
                            id={commonService.generateGlobalClickTrackerID(
                                "PickupAndPace",
                                "emailIcon",
                                propertyDetailFromRTK?.propertyid,
                            )}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.PickupAndPaceTable,
                                    "PickupAndPace",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId,
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img
                            id={commonService.generateGlobalClickTrackerID(
                                "PickupAndPace",
                                "infoIcon",
                                propertyDetailFromRTK?.propertyid,
                            )}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PickupAndPace || "PickupAndPace",
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img
                            src={downloadIcon}
                            import={tblids.PickupAndPaceTable}
                            alt="menuIcon"
                            id={commonService.generateGlobalClickTrackerID(
                                "PickupAndPace",
                                "downloadIcon",
                                propertyDetailFromRTK?.propertyid,
                            )}
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.PickupAndPaceTable,
                                    `${para?.propertyCode}-PickupAndPace-${moment(new Date()).format("MMDDYYYY")}`,
                                );
                            }}
                        />
                    </Button>
                </div>
            )}

            <div className="ViewPropertySetupTable mainTableClass">
                <div className="stripped__table">
                    <div className="table-responsive tblDynamicPickupSticky">
                        <Table
                            id={tblids.PickupAndPaceTable}
                            hover
                            className="table-with-spacing positionStaticTable dailySummaryTbl"
                        >
                            <thead className="tbl-header-sticky">
                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th className="border-right">DATE</th>
                                    <th className="border-right text-center">OTB </th>
                                    {/* <th className="border-right text-center">RM Copilot FC</th> */}
                                    <th className="border-right text-center">SYSTEM FC</th>
                                    <th className="border-right text-center">1D PU</th>
                                    <th className="border-right text-center">3D PU</th>
                                    <th className="border-right text-center">7D PU</th>
                                    <th className="border-right text-center">VS STLY</th>
                                    <th className="border-right text-end">BAR</th>
                                    <th className="border-right text-center">SIGNAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingOccData ? (
                                    <tr style={{ height: "80px", position: "relative" }}>
                                        <Loader />
                                    </tr>
                                ) : data.length === 0 ? (
                                    <tr>
                                        <td colSpan={9} className="text-center p-4">
                                            No Data found
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((row, i) => {
                                        return (
                                            <tr
                                                key={i}
                                                style={{ cursor: api === 0 ? "default" : "pointer" }}
                                                id={commonService.generateGlobalClickTrackerID(
                                                    "PickupAndPace",
                                                    "PickupAndPace-row-click",
                                                    row.date,
                                                )}
                                                onClick={() => {
                                                    if (api === 0) return;
                                                    let filteredRow = modalData.filter(
                                                        (itm) => itm.date === row.Dates,
                                                    );
                                                    setSelectedDateData(filteredRow[0]);
                                                    setShowDetail(true);
                                                }}
                                            >
                                                <td className="border-right">{row.date}</td>
                                                <td className="border-right text-center ">
                                                    {commonService?.formateRoom(row.otb)}
                                                </td>
                                                <td className="border-right text-center ">
                                                    {commonService?.formateRoom(row.novaFc)}
                                                </td>
                                                <td className="border-right text-center ">
                                                    {commonService?.formateRoom(row.pu1d)}
                                                </td>
                                                <td className="border-right text-center ">
                                                    {commonService?.formateRoom(row.pu3d)}
                                                </td>
                                                <td className="border-right text-center ">
                                                    {commonService?.formateRoom(row.pu7d)}
                                                </td>
                                                <td className="border-right text-center ">
                                                    {renderColorText(
                                                        commonService?.formateRoom(row.vsStly),
                                                    )}
                                                </td>
                                                <td className="border-right text-end ">
                                                    {commonService?.formateAmount(row.bar)}
                                                </td>
                                                <td className="border-right text-center">
                                                    <span style={getBadgeStyle(row.signal)}>
                                                        {row.signal}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {selectedDateData && showDetail && (
                <MorningBriefingDateDetailModal
                    showDetail={showDetail}
                    setShowDetail={setShowDetail}
                    selectedDateData={selectedDateData}
                    rateShopData={rateShopData}
                    bookingPaceData={bookingPaceData}
                    marketSegmentMixData={marketSegmentMixData}
                    isLoadingRateShop={isLoadingRateShop}
                    isLoadingBookingPace={isLoadingBookingPace}
                    isLoadingMarketSegmentMix={isLoadingMarketSegmentMix}
                />
            )}
            {api !== 0 && (
                <Comments
                    widgetDetails={para}
                    editorId={"PickupAndPace" + tblids.PickupAndPaceTable}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default PickupAndPace;
